import Storage from './localStorage';
const UA = window.navigator.userAgent;

export const inShopeeApp = () => {
  return UA.toLowerCase().indexOf('shopee') > -1;
};

export const inAndroid = () => {
  return UA.toLowerCase().indexOf('android') > -1;
};

export const inIphone = () => {
  return UA.toLowerCase().indexOf('iphone') > -1;
};

export const inMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    UA
  );
};

export const getAppVer = () => {
  const matched = /appver=(\d*)/.exec(window.navigator.userAgent);
  if (matched) {
    return matched[1];
  }
};

export const firstLetterUpper = (str: any, allWords = true) => {
  let tmp = str.replace(/^(.)/g, ($1: any) => $1.toUpperCase());
  if (allWords) {
    tmp = tmp.replace(/\s(.)/g, ($1: any) => $1.toUpperCase());
  }
  return tmp;
};


export const getUrlQueryValue = (name: any) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return decodeURIComponent(r[2]);
  } else {
    return null;
  }
};

export const setLanguageToCookie = (language: any) => {
  const lang = Storage.getItem('language');
  language = language || lang;
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 1000 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = 'fms_language=' + language + '; path=/' + expires;
};

export const setCookie = (cookieName: any, value: any, expiredTime?: any) => {
	const defaultExpiredTime = 24 * 60 * 1000 * 1000;
  const time = expiredTime || defaultExpiredTime;
  const date = new Date();
	date.setTime(date.getTime() + time);
	const expires = "; expires=" + date.toUTCString();
	document.cookie = `${cookieName}=${value}; path=/`+ expires;
};